/*
#####################
##### SETTINGS ######
#####################
*/

export const users = {
    entity: "User",
    body: "id, name, username, role, blocked, organizationName, hasUpgradedAccount, lastSignInAt",
    xlsxExport: "id, name, username, role",
};

export const organizations = {
    entity: "Organization",
    body: "id,name,packageName,active,expirationDate",
};

export const projects = {
    entity: "Project",
    body: "id, description, taxRegistrationNumber, organization{ name }, fiscalYears, active",
};

export const project = {
    entity: "Project",
    body: "id, description, taxRegistrationNumber, organization{ name }, fiscalYears, active",
};

export const nc_rules = {
    entity: "NcRule",
    body: "id, RuleID,RuleType,Severity,Description",
};

export const kpis = {
    entity: "Kpi",
    body: "id, KpiID, Description, KpiType",
};

export const custom_reports = {
    entity: "CustomReportSettings",
    body: "id, ReportName, Active",
};

export const packages = {
    entity: "Package",
    body: "id, name, description, kpisCounter, rulesCounter, crCounter",
};

export const package_kpis = {
    entity: "PackagesAssociationKpis",
    body: "id, KpiID, Description, KpiType, selected",
};

export const package_rules = {
    entity: "PackagesAssociationRules",
    body: "id, RuleID,RuleType,Severity,Description, selected",
};

export const package_custom_reports = {
    entity: "PackagesAssociationCustomReports",
    body: "id, ID, ReportName, Active, selected",
};

export const translations_table = {
    entity: "TranslationTable",
    body: "id, name, description, entity, organizationId, datasetLocale",
};

/*
#####################
##### SETTINGS ######
#####################
*/

/*
##########################
##### REPOSITORY ######
#########################
*/

export const activity = {
    entity: "Activity",
    body: "__typename,id,name,type,status,uploadedAt,startDate,endDate,submittedBy,checked,projectId,fiscalYear,subType,statusCode,fileSizeDecompress,internalStatus",
};

export const activity_detail = {
    entity: "ActivityDetail",
    body: "id,name,version,type,findingType,findingMessage,uploadedAt,uploadedByName,status,fiscalYear",
};

export const folders = {
    entity: "DataFile",
    body: "__typename,id,name,type,status,uploadedAt,startDate,endDate,submittedBy,checked,projectId,fiscalYear,auditStatus,statusCode,internalStatus,fileSubmittedAt,subType,fileSubmittedBy",
};

export const merge_collisions = {
    entity: "RepositoryMetadata",
    body: "__typename, fileName, fileType, fiscalYear, P01Count, P02Count, P03Count, P04Count, P05Count, P06Count, P07Count, P08Count, P09Count, P10Count, P11Count, P12Count, DocIDate, DocFDate, DocumentCategory, DocType, Series, TaxEntity, NumDocs, ID, TaxAccountingBasis, DateCreated, DocIHash, P01DocI, P02DocI, P03DocI, P04DocI, P05DocI, P06DocI, P07DocI, P08DocI, P09DocI, P10DocI, P11DocI, P12DocI, P01DocIHash, P02DocIHash, P03DocIHash, P04DocIHash, P05DocIHash, P06DocIHash, P07DocIHash, P08DocIHash, P09DocIHash, P10DocIHash, P11DocIHash, P12DocIHash, POtherDocIHash, P01DocF, P02DocF, P03DocF, P04DocF, P05DocF, P06DocF, P07DocF, P08DocF, P09DocF, P10DocF, P11DocF, P12DocF, POtherDocF,DocI,DocF",
};

export const invalid_files = {
    entity: "InvalidDataFile",
    body: "__typename,id,name,type,status,uploadedAt,startDate,endDate,submittedBy,checked,projectId,fiscalYear,auditStatus",
};

export const merge_history = {
    entity: "MergeHistory",
    body: "__typename,id, status, createdAt, updatedAt, fileType, filesIds, fiscalYear",
};

export const deleted_file_logs = {
    entity: "DeleteFileLogs",
    body: "__typename,fileId,userId,projectId,deletedAt,deletedBy,fileName,fileType,uploadedAt,fileSizeDecompress,originStatus",
    xlsxExport:
        "fileId,fileName,fileType,originStatus,uploadedAt,fileSizeDecompress,deletedBy,deletedAt",
};

export const invalid_files_detail = {
    entity: "InvalidDataFile",
    body: "id,name,uploadedAt,submittedBy,type,version, statusCode, status, fiscalYear,typeAggregated, moduleByDataFileType",
};

export const folders_detail = {
    entity: "FolderDetail",
    body: "id,name,type,status,uploadedAt,startDate,version,moduleByDataFileType,endDate,submittedBy,version,totalFindings{severity,count}, statusCode, status, fiscalYear, entitiesKpis{entity,count}, hasNavigationByImportId, defaultRoute",
};

export const submission_saft_detail = {
    entity: "FolderDetail",
    body: "id,name,type,status,uploadedAt,startDate,version,moduleByDataFileType,endDate,submittedBy,version,totalFindings{severity,count}, statusCode, status, fiscalYear, entitiesKpis{entity,count}, hasNavigationByImportId, defaultRoute",
};

/*
##########################
##### REPOSITORY ######
#########################
*/

/*
################################################
##### AUDIT, FINANCIAL REPORTS AND OTHERS ######
################################################
*/

export const projectSummary = {
    entity: "ProjectSumary",
    body: "invoicesNetTotal,invoicesGrossTotal,invoicesNetAverage,invoicesMaxValue,transactionLinesCount,transactionsCount,leafAccountsCount,generalLedgersCount,invoiceLinesCount,invoicesCount,productsInvoicesCount,customersInvoicesCount,taxCodesCount,productsCodeCount,productsGroupCount,productsCount,suppliersCountriesCount,suppliersNifCount,suppliersCount,customersCountriesCount,customersNifCount,customersCoun,setClose",
    xlsxExport:
        "invoicesNetTotal,invoicesGrossTotal,invoicesNetAverage,invoicesMaxValue,transactionLinesCount,transactionsCount,leafAccountsCount,generalLedgersCount,invoiceLinesCount,invoicesCount,productsInvoicesCount,customersInvoicesCount,taxCodesCount,productsCodeCount,productsGroupCount,productsCount,suppliersCountriesCount,suppliersNifCount,suppliersCount,customersCountriesCount,customersNifCount,customersCoun",
};

export const generation = {
    entity: "GeneratorDataFile",
    body: "__typename, fileId, projectId,dateFrom,fileType,dateTo,userId,status,message,userName,createdAt,fileTypeName,id,fileName, detailPanel{data{entity, isMandatory, severity,status,auditStatus,dataIntegrity, schema}},fiscalYear",
};

export const findings = {
    entity: "Finding",
    body: "id,severity,referenceType,referenceId,createdAt",
    xlsxExport: "id,severity,referenceType,referenceId,createdAt",
};

export const finding = {
    entity: "Finding",
    body: "id,message,messageParameter,severity,referenceType,referenceId,createdAt,type,line,column,xmlBlock,ruleTitle, audit_note(projectId:$projectId,modulePrefix:$modulePrefix){id,message,justified}",
};

export const audit_finding = {
    entity: "FindingErrorStructure",
    body: "message, originalMessage, line, column, xmlBlock,type,referenceType",
};
export const adhoc_audit_notes_by_entity = {
    entity: "AuditNoteRecord",
    body: "AuditStatus,AuditNote,CreatedBy,CreationDate",
};

export const balance_sheet = {
    entity: "BalanceSheet",
    body: "KPIKey,Description,CurrentValue,CurrentValueYearN1,CurrentValueYearN2,CurrentValueYearN3,groupingLine,CurrencyOptions",
    xlsxExport:
        "Category2,Category3,KPIKey,Description,CurrentValue,CurrentValueYearN1,CurrentValueYearN2,CurrentValueYearN3",
};

export const profit_and_loss = {
    entity: "ProfitAndLoss",
    body: "KPIKey,Description,CurrentValue,CurrentValueYearN1,CurrentValueYearN2,CurrentValueYearN3,groupingLine,CurrencyOptions",
    xlsxExport:
        "Category2,Category3,KPIKey,Description,CurrentValue,CurrentValueYearN1,CurrentValueYearN2,CurrentValueYearN3",
};

export const nc_findings_for_record = {
    entity: "NCRuleFinding",
    body: "id,DescriptionPreview,Severity,RuleType,Entity,RuleID,NumberOfFindings",
};

export const nc_trial_balance = {
    entity: "NcTrialBalance",
    body: "AccountID,TaxonomyCode,CLB_Period,Debit,Credit,SumBalDebit,SumBalCredit,AccumulatedDebit,AccumulatedCredit,MaxPeriod,CurrencyOptions,AccountDescription,GroupingCategory",
    xlsxExport:
        "AccountID,AccountDescription,TaxonomyCode,Debit,Credit,AccumulatedDebit,AccumulatedCredit,SumBalDebit,SumBalCredit",
};

export const nc_rules_summary = {
    entity: "NCRuleFinding",
    body: "id,details,DescriptionPreview,Severity,RuleID,RuleType,Entity,ModulePrefixByFileType,NumberOfFindings",
};

export const nc_findings_summary = {
    entity: "NCAuditSummary",
    body: "severity,count",
};

export const nc_audit_notes = {
    entity: "AuditNote",
    body: "id,AuditStatus,AuditNote,CreatedBy,CreatedAt,ModifiedBy,UpdatedAt,Source,Origin,RowID,EntityName,modulePrefix",
};

export const nc_audit_execution_summary = {
    entity: "NcAuditExecutionSummary",
    body: "id,dataFileName,dataFileType,ruleId,ruleIdentifier,result,createdAt,description,isRuleProcessing",
    xlsxExport: "ruleIdentifier,description,dataFileName,result,createdAt",
};
export const nc_trial_balance_taxonomy_pluriannual = {
    entity: "NcTrialBalanceTaxonomyPluriannual",
    body: "Taxonomy,SumBalDebitCurrent,SumBalCreditCurrent,SumBalDebitN1,SumBalCreditN1,SumBalDebitN2,SumBalCreditN2,SumBalDebitN3,SumBalCreditN3,TaxonomyCode,CurrencyOptions,DebitCreditIndicator",
    xlsxExport:
        "Taxonomy,DebitCreditIndicator,SumBalDebitCurrent,SumBalCreditCurrent,SumBalDebitN1,SumBalCreditN1,SumBalDebitN2,SumBalCreditN2,SumBalDebitN3,SumBalCreditN3",
};

export const nc_trial_balance_taxonomy = {
    entity: "NcTrialBalanceTaxonomy",
    body: "Taxonomy,SumBalDebit,SumBalCredit,Debit,Credit,AccDebit,AccCredit,TaxonomyCode,DebitCreditIndicator,CurrencyOptions",
    xlsxExport:
        "Taxonomy,DebitCreditIndicator,Debit,Credit,AccDebit,AccCredit,SumBalDebit,SumBalCredit",
};

export const nc_trial_balance_pluriannual = {
    entity: "NcTrialBalancePluriannual",
    body: "AccountID,SumBalDebit,SumBalCredit,SumBalDebitN1,SumBalCreditN1,SumBalDebitN2,SumBalCreditN2,SumBalDebitN3,SumBalCreditN3,MaxPeriod,CurrencyOptions",
    xlsxExport:
        "AccountID,SumBalDebit,SumBalCredit,SumBalDebitN1,SumBalCreditN1,SumBalDebitN2,SumBalCreditN2,SumBalDebitN3,SumBalCreditN3",
};

export const nc_statement_accounts_accumulated = {
    entity: "NcStatementAccountAccumulated",
    body: "AccountID,Description,CreditAmount,DebitAmount,TransactionID,JournalID,Period,AccumulatedNet,CurrencyOptions,TransactionDate",
    xlsxExport:
        "AccountID,TransactionID,Description,JournalID,TransactionDate,Period,DebitAmount,CreditAmount,AccumulatedNet",
};

export const nc_offsetting_account = {
    entity: "NcOffsettingAccount",
    body: "AccountID,Description,CreditAmount,DebitAmount,TransactionID,JournalID,Period,ID,CurrencyOptions,TransactionDate",
    xlsxExport:
        "AccountID,TransactionID,Description,JournalID,TransactionDate,Period,DebitAmount,CreditAmount",
};

export const submission_saft = {
    entity: "DataFileSubmission",
    body: "__typename,id,name,type,uploadedAt,startDate,endDate,submittedBy,checked,projectId,fiscalYear,auditStatus,statusCode,internalStatus,fileSubmittedAt,fileSubmittedBy,hasHighFindings,submissionStatus,submissionId, fileSizeDecompress, subType, responseMultidocFilePath",
};

export const import_profiles = {
    entity: "ImportProfile",
    body: "__typename, id, profile_name, profile_headers, created_at, updated_at, has_mapping, status",
};

export const audit_findings = {
    entity: "NCAuditError",
    body: "__typename, type, message, createdAt, lineNumber, columnNumber, xmlBlock",
    xlsxExport: "lineNumber, columnNumber, type, message, createdAt",
};

export const custom_reports_by_project = {
    entity: "CustomReport",
    body: "__typename, id, ID, ReportName, ReportActiveInProject",
};

export const fact_custom = {
    entity: "FactCustom",
    body: "__typename,ColumnsByLocale,FieldsData",
};
